"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listFuelTypes = void 0;
const fuelTypes_1 = require("./consts/fuelTypes");
const formatFuelType_1 = require("./utils/formatFuelType");
const listFuelTypes = () => fuelTypes_1.fuelTypes.map(formatFuelType_1.formatFuelType);
exports.listFuelTypes = listFuelTypes;
